export default function MapEditorTabBtn({title, active, cb, className, children, disabled}){
    return (
        <button 
            title={title || ''}
            type="button" 
            onClick={cb}
            disabled={disabled || false}
            className={`border-b border-b-transparent p-2 h-10 transition-colors ${active? 'bg-black text-white border-b-black':'hover:border-b-black hover:bg-gray-100 disabled:border-transparent disabled:text-gray-400'} ${className || ''}`}
        >
            {children}
        </button>
    )
}